import { render, staticRenderFns } from "./return_stock.vue?vue&type=template&id=1a563b23&"
import script from "./return_stock.vue?vue&type=script&lang=js&"
export * from "./return_stock.vue?vue&type=script&lang=js&"
import style0 from "./return_stock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports